import React, { useEffect, useState } from "react";
import { PageHero } from "@/components/Shared";
import { infoPages } from "@/pages/infoContent";
import api from "@/lib/api";
import { Check } from "lucide-react";

export default function InfoPage({ slug }) {
  const [page, setPage] = useState(infoPages[slug]);

  useEffect(() => {
    setPage(infoPages[slug]);
    api.get("/content").then((r) => {
      const override = r.data?.pages?.[slug];
      if (override && Array.isArray(override.sections)) setPage(override);
    }).catch(() => {});
  }, [slug]);

  if (!page) return null;
  const sections = page.sections;
  return (
    <div data-testid={`info-page-${slug}`}>
      <PageHero title={page.title} subtitle={page.subtitle} testId={`info-hero-${slug}`} />
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24 space-y-14">
        {sections.map((s, i) => (
          <div key={i} className="animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
            {s.h && <h3 className="font-display text-xl sm:text-2xl font-bold text-gold mb-4">{s.h}</h3>}
            {s.p && <p className="text-slate-300 leading-relaxed text-base whitespace-pre-line">{s.p}</p>}
            {s.list && s.list.length > 0 && (
              <ul className="mt-3 space-y-3">
                {s.list.map((li, j) => (
                  <li key={j} className="flex gap-3 text-slate-300">
                    <Check className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                    <span>{li}</span>
                  </li>
                ))}
              </ul>
            )}
            {s.table && (
              <div className="mt-5 border border-white/10 overflow-hidden">
                <table className="w-full text-left">
                  <thead className="bg-secondary">
                    <tr>{s.table.head.map((h, k) => <th key={k} className="px-5 py-3 text-gold text-sm uppercase tracking-wider">{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {s.table.rows.map((row, r) => (
                      <tr key={r} className="border-t border-white/5 hover:bg-white/5">
                        {row.map((c, k) => <td key={k} className={`px-5 py-3 ${k === 0 ? "text-white font-medium" : "text-slate-300"}`}>{c}</td>)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
